import gql from 'graphql-tag'

export const ReadErrorFragment = gql`
  fragment ReadErrorFragment on ReadError {
    message
  }
`
